import { render, staticRenderFns } from "./SingleOrganization.vue?vue&type=template&id=f057039a&scoped=true&"
import script from "./SingleOrganization.vue?vue&type=script&lang=ts&"
export * from "./SingleOrganization.vue?vue&type=script&lang=ts&"
import style0 from "./SingleOrganization.vue?vue&type=style&index=0&id=f057039a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f057039a",
  null
  
)

export default component.exports